class Animations {
  constructor() {
    this.events();
  }

  events() {
    window.addEventListener("scroll", () => this.reveal());

    const onReady = () => {
      this.fixRevealRight();

      setTimeout(() => {
        this.reveal();
      }, 500);
    };

    if (document.readyState === "complete") {
      onReady();
    } else {
      window.addEventListener("load", onReady);
    }
  }

  reveal() {
    const reveals = document.querySelectorAll(".reveal");

    reveals.forEach((el) => {
      const windowHeight = window.innerHeight;
      const elementTop = el.getBoundingClientRect().top;
      const elementVisible = 200;

      if (elementTop < windowHeight - elementVisible) {
        el.classList.add("active");
      } else {
        el.classList.remove("active");
      }
    });
  }

  fixRevealRight() {
    const revealRightElements = document.querySelectorAll(".reveal.right");
    revealRightElements.forEach((element) => {
      if (element.parentElement) {
        element.parentElement.style.overflow = "hidden";
      }
    });
  }
}

export default Animations;